import type { LabelHTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface OnboardingLabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  children: ReactNode
}

export function OnboardingLabel({
  children,
  className,
  ...props
}: OnboardingLabelProps) {
  return (
    <label
      className={cn('mb-1.5 block text-sm font-medium text-[#414651]', className)}
      {...props}
    >
      {children}
    </label>
  )
}
